module.exports = __webpack_public_path__ + "static/meet_logo-6f1dd6811d528b7325dfde6fabb07fba.png";